import React from 'react';
import {useSelector} from 'react-redux';

import {
    Badge as AlchemyBadge,
} from '@amzn/alchemy-components-react';

import { RootState } from '../../types/RootState.type';

const Content = () => {
    const currentUser = useSelector((state: RootState) => state.user)
    const mobileView = useSelector((state: RootState) => state.mobileView)
    const normalBadge =
        <AlchemyBadge
            label={currentUser.login || "Anonymous"}
            image={`https://internal-cdn.amazon.com/badgephotos.amazon.com/?uid=${currentUser.login || "Anonymous"}`}
        />

    const mobileBadge =
        <AlchemyBadge
            image={`https://internal-cdn.amazon.com/badgephotos.amazon.com/?uid=${currentUser.login || "Anonymous"}`}
        />

    return (
        mobileView ? mobileBadge : normalBadge
    )}

export default function() {
    return (
        <Content />
    );
}